import React from 'react'

// this function will get list of property types that the advertiser has opted for
//  farm house, commercial,  residential, Rented etc 
//  advertiser will pass PropertyTypes array of  object of type {id,propertytype} whereas id is property type
// wheren ever user has selected that property type it will get displayed
//  at the moment its not colony specifiy, if its colony specifi, it will be retrived from colony advertiser is working for


import img2 from '../../assets/ads/space/banner/2.png'//farms
import img3 from '../../assets/ads/space/banner/3.png'  ; // builder floors
import img4 from '../../assets/ads//space/banner/4.png'; // full 
import SliderComponent from './ImageSlider';






// url will always be the profile id of advertiser


function PropertyTypeSlider({PropertyTypes}) {

//    console.log("property types",PropertyTypes);

    let firstrow=PropertyTypes[0]?.id;
    
    //console.log("firstrow",firstrow);
    
    firstrow=Number(firstrow)  ;

    firstrow=8;

    let img=null;
    let defaultimg= { image: img4, title: "", description: "",url:"/displayprofile/112" }
   
    switch (firstrow)
    {
        case 1:
            // 'apartment'            
        case 2:
            // 'builder floor'
        img ={ image: img3, title: "", description: "",url:"/displayprofile/112" }
            break;
        case 3:
            // 'collaboration'
        case 4:
            // 'commercial'
        case 5:
            // 'commercial plot'
        case 9:
            // 'dda flat'
            img ={ image: img4, title: "", description: "",url:"/displayprofile/112" }
            break;
        case 10:
            // 'farm'
            img ={ image: img2, title: "", description: "",url:"/displayprofile/112" }
            break
        case 11:
            // 'farm house'
            img ={ image: img2, title: "", description: "",url:"/displayprofile/112" }
            break;
        case 12:
            // 'flat'
        case 13:
            // 'floor'
        default :
        
    }

//   console.log("img",img);     
 
    if (img==null){
        img=defaultimg
    }



  return (
    
        <div className='categorySlider'>
            <SliderComponent
            
                images={[
                    img
                    // { image: img2, title: "", description: "",url:"/displayprofile/112" },
                    // { image: img4, title: "", description: "" ,url:"/displayprofile/112"},
            
                ]}
                duration={5000}
                //   titleStyle="text-sm font-semibold bg-black bg-opacity-60 px-3 py-1 rounded"
                //   descriptionStyle="text-xs bg-black bg-opacity-40 px-2 py-1 rounded"
                allowFade={true}
                showBullet={false}     // Correct prop name (from SliderComponent.jsx)
                showArrowIcons={false}
                containerWidth="100%" // Adjusted to fit the container
                containerHeight="150px"
                //   headflash={["Find your dream home", "Exclusive listings","Register Free","Nominal Subscription", "Hurry! Limited time offers","Seamleass User Experience"]}
                //   headflashstyle="custom-headflash"
                //   headflashduration={2000}
            
            
            
            
            >

            </SliderComponent>
        </div>  
    
  )
}

export default PropertyTypeSlider
